import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsDivider } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        VBreadcrumbs,
        { staticClass: "d-print-none" },
        [
          _c(
            VBreadcrumbsItem,
            { attrs: { exact: true, to: { name: "home", params: {} } } },
            [_vm._v("Home")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(
            VBreadcrumbsItem,
            {
              attrs: {
                exact: true,
                to: { name: "processWorksheet", params: {} },
              },
            },
            [_vm._v(" Process Worksheet ")]
          ),
          _c(VBreadcrumbsDivider, [_vm._v("/")]),
          _c(
            VBreadcrumbsItem,
            { attrs: { to: { name: "processWorksheetView", params: {} } } },
            [_vm._v(" Worksheet Print Label ")]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "d-print-none" },
        [
          _c(
            "div",
            {
              staticClass: "d-flex justify-center align-center flex-wrap my-2",
            },
            [
              _c(
                VBtn,
                {
                  staticClass: "ma-1",
                  attrs: {
                    color: _vm.preferBluetooth ? "indigo" : "primary",
                    dark: "",
                    large: "",
                    loading: _vm.btBusy,
                    disabled: _vm.btBusy,
                  },
                  on: {
                    click: function ($event) {
                      _vm.preferBluetooth ? _vm.printBluetooth() : _vm.print()
                    },
                  },
                },
                [
                  _c(VIcon, { attrs: { left: "" } }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.preferBluetooth ? "mdi-bluetooth" : "mdi-printer"
                        ) +
                        " "
                    ),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.preferBluetooth
                          ? "พิมพ์ (บลูทูธ)"
                          : "พิมพ์ (USB / WiFi)"
                      ) +
                      " "
                  ),
                ],
                1
              ),
              _vm.btSupported
                ? _c(
                    VBtn,
                    {
                      staticClass: "ma-1",
                      attrs: { text: "", small: "", disabled: _vm.btBusy },
                      on: {
                        click: function ($event) {
                          _vm.preferBluetooth
                            ? _vm.print()
                            : _vm.printBluetooth()
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.preferBluetooth
                              ? "ใช้ USB / WiFi แทน"
                              : "ใช้บลูทูธแทน"
                          ) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.btBusy
                ? _c(
                    VBtn,
                    {
                      staticClass: "ma-1",
                      attrs: { color: "red", outlined: "", large: "" },
                      on: {
                        click: function ($event) {
                          return _vm.cancelBluetooth()
                        },
                      },
                    },
                    [
                      _c(VIcon, { attrs: { left: "" } }, [
                        _vm._v("mdi-stop"),
                      ]),
                      _vm._v(" ยกเลิก / Cancel "),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.btSupported
                ? _c(VTextField, {
                    staticClass: "ma-1 flex-grow-0",
                    staticStyle: { "max-width": "130px" },
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      type: "number",
                      min: "1",
                      max: "20",
                      disabled: _vm.btBusy,
                      label: "สำเนา / Copies",
                    },
                    model: {
                      value: _vm.parameters.copies,
                      callback: function ($$v) {
                        _vm.$set(_vm.parameters, "copies", _vm._n($$v))
                      },
                      expression: "parameters.copies",
                    },
                  })
                : _vm._e(),
              !_vm.btBusy
                ? _c(VSelect, {
                    staticClass: "ma-1 flex-grow-0",
                    staticStyle: { "max-width": "160px" },
                    attrs: {
                      value: _vm.sizeKey,
                      items: _vm.sizeItems,
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      label: "ขนาด / Size",
                    },
                    on: { change: _vm.applySize },
                  })
                : _vm._e(),
              !_vm.btBusy
                ? _c(VTextField, {
                    staticClass: "ma-1 flex-grow-0",
                    staticStyle: { "max-width": "150px" },
                    attrs: {
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                      clearable: "",
                      placeholder: "all",
                      label: "เฉพาะข้อ / Only #",
                    },
                    model: {
                      value: _vm.filterTerm,
                      callback: function ($$v) {
                        _vm.filterTerm = $$v
                      },
                      expression: "filterTerm",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm.btSupported && _vm.btProgress.total
            ? _c(
                "div",
                {
                  staticClass: "mx-auto mb-2",
                  staticStyle: { "max-width": "480px" },
                },
                [
                  _c(VProgressLinear, {
                    attrs: {
                      value: (_vm.btProgress.done / _vm.btProgress.total) * 100,
                      height: "6",
                      rounded: "",
                      color: "indigo",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.btStatus
            ? _c(
                "div",
                { staticClass: "text-center text-caption grey--text mb-2" },
                [_vm._v(" " + _vm._s(_vm.btStatus) + " ")]
              )
            : _vm._e(),
          _vm.btLog.length
            ? _c(
                VCard,
                {
                  staticClass: "mx-auto mb-3",
                  attrs: { outlined: "", "max-width": "480" },
                },
                [
                  _c(
                    VCardText,
                    { staticClass: "py-2" },
                    _vm._l(_vm.btLog, function (line, i) {
                      return _c(
                        "div",
                        {
                          key: i,
                          staticClass: "text-caption",
                          staticStyle: {
                            "font-family": "monospace",
                            "white-space": "pre-wrap",
                          },
                        },
                        [_vm._v(" " + _vm._s(line) + " ")]
                      )
                    }),
                    0
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            VExpansionPanels,
            { staticClass: "mb-5", attrs: { flat: "" } },
            [
              _c(
                VExpansionPanel,
                [
                  _c(VExpansionPanelHeader, [
                    _vm._v("Advanced Print Settings"),
                  ]),
                  _c(
                    VExpansionPanelContent,
                    [
                      _c("page-params", {
                        attrs: {
                          pageName: "worksheetPrintLabel",
                          vuexName: "labelPrintParameters",
                          parameters: _vm.settings,
                        },
                        on: {
                          onLoad: function ($event) {
                            _vm.manualPresetLoaded = true
                          },
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "text-caption grey--text mx-2 mb-2" },
                        [
                          _vm._v(
                            ' Brand name, commodity override and extra fields are remembered per product automatically: whatever you print with becomes the default the next time "' +
                              _vm._s(
                                _vm.processWorksheet.productName ||
                                  "this product"
                              ) +
                              '" labels are printed. '
                          ),
                        ]
                      ),
                      _c(VDivider),
                      _c(VSubheader, [_vm._v("Label Print Settings")]),
                      _c("div", [
                        _c(
                          "div",
                          { staticClass: "d-flex" },
                          [
                            _c(VTextField, {
                              staticClass: "mx-2",
                              attrs: {
                                label: "Brand Name",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.parameters.brandName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.parameters, "brandName", $$v)
                                },
                                expression: "parameters.brandName",
                              },
                            }),
                            _c(VTextField, {
                              staticClass: "mx-2",
                              attrs: {
                                label: "Commodity Override",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.parameters.commodityOverride,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.parameters,
                                    "commodityOverride",
                                    $$v
                                  )
                                },
                                expression: "parameters.commodityOverride",
                              },
                            }),
                            _c(
                              VBtn,
                              {
                                staticClass: "ml-2",
                                on: {
                                  click: function ($event) {
                                    return _vm.addStickerField()
                                  },
                                },
                              },
                              [_vm._v("Add Field")]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._l(
                        _vm.parameters.optionalFields,
                        function (field, index) {
                          return _c("div", { key: index }, [
                            _c(
                              "div",
                              { staticClass: "d-flex" },
                              [
                                _c(VTextField, {
                                  staticClass: "mx-2",
                                  attrs: {
                                    label: "Field Label",
                                    outlined: "",
                                    dense: "",
                                  },
                                  model: {
                                    value: field.label,
                                    callback: function ($$v) {
                                      _vm.$set(field, "label", $$v)
                                    },
                                    expression: "field.label",
                                  },
                                }),
                                _c(VTextField, {
                                  staticClass: "mx-2",
                                  attrs: {
                                    label: "Field Value",
                                    outlined: "",
                                    dense: "",
                                  },
                                  model: {
                                    value: field.value,
                                    callback: function ($$v) {
                                      _vm.$set(field, "value", $$v)
                                    },
                                    expression: "field.value",
                                  },
                                }),
                                _c(
                                  VBtn,
                                  {
                                    attrs: { icon: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteField(index)
                                      },
                                    },
                                  },
                                  [
                                    _c(VIcon, [
                                      _vm._v("mdi-delete-outline"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        }
                      ),
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "mm",
                              outlined: "",
                              dense: "",
                              label: "Label Width",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.labelWidth,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "labelWidth", $$v)
                              },
                              expression: "parameters.labelWidth",
                            },
                          }),
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "mm",
                              outlined: "",
                              dense: "",
                              label: "Label Height",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.labelHeight,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "labelHeight", $$v)
                              },
                              expression: "parameters.labelHeight",
                            },
                          }),
                          _c(VSwitch, {
                            staticClass: "mx-2 mt-1",
                            attrs: {
                              dense: "",
                              label: "Rotate 90°",
                              hint: "Match printers that feed labels portrait",
                              "persistent-hint": "",
                            },
                            model: {
                              value: _vm.parameters.rotate,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "rotate", $$v)
                              },
                              expression: "parameters.rotate",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "px",
                              outlined: "",
                              dense: "",
                              label: "Left",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.left,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "left", $$v)
                              },
                              expression: "parameters.left",
                            },
                          }),
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "px",
                              outlined: "",
                              dense: "",
                              label: "Top",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.top,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "top", $$v)
                              },
                              expression: "parameters.top",
                            },
                          }),
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "px",
                              outlined: "",
                              dense: "",
                              label: "Right",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.right,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "right", $$v)
                              },
                              expression: "parameters.right",
                            },
                          }),
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "px",
                              outlined: "",
                              dense: "",
                              label: "Bottom",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.bottom,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "bottom", $$v)
                              },
                              expression: "parameters.bottom",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "d-flex" },
                        [
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "pt",
                              outlined: "",
                              dense: "",
                              label: "Font Size",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.fontSize,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "fontSize", $$v)
                              },
                              expression: "parameters.fontSize",
                            },
                          }),
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "pt",
                              outlined: "",
                              dense: "",
                              label: "Header Font Size",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.headerFontSize,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "headerFontSize", $$v)
                              },
                              expression: "parameters.headerFontSize",
                            },
                          }),
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "pt",
                              outlined: "",
                              dense: "",
                              label: "Footer Font Size",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.footerFontSize,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "footerFontSize", $$v)
                              },
                              expression: "parameters.footerFontSize",
                            },
                          }),
                          _c(VTextField, {
                            staticClass: "mx-2",
                            attrs: {
                              suffix: "pt",
                              outlined: "",
                              dense: "",
                              label: "QR Code Size",
                              type: "number",
                            },
                            model: {
                              value: _vm.parameters.qrSize,
                              callback: function ($$v) {
                                _vm.$set(_vm.parameters, "qrSize", $$v)
                              },
                              expression: "parameters.qrSize",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(VDivider, { staticClass: "mb-5" }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "sticker-container" },
        _vm._l(_vm.filteredEntries, function (entry) {
          return _c(
            "div",
            { key: entry.id, staticClass: "label-page" },
            [
              _c("label-sticker", {
                attrs: {
                  entry: entry,
                  worksheet: _vm.processWorksheet,
                  parameters: _vm.parameters,
                  "qr-data-url": _vm.qrDataUrls[entry.id] || "",
                  "lot-index": _vm.entryIndex(entry),
                  "commodity-name": _vm.commodityName,
                  "product-info": _vm.productInfo,
                  "company-name": _vm.companyName,
                  "company-address": _vm.companyAddress,
                  "company-phone": _vm.companyPhone,
                  "document-mode": _vm.documentLabelMode,
                  "document-net-weight": _vm.documentLabelMode
                    ? _vm.documentNetWeight
                    : null,
                  "document-number": _vm.documentLabelMode
                    ? _vm.documentNumber
                    : "",
                },
              }),
            ],
            1
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }